import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  Input,
  Space,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import axios from "axios";

import {
  CreateReligionMaster,
  GetReligionMaster,
  UpdateReligionMaster,
} from "../../../AllAPI/AdminAPI";
import { toast } from "react-toastify";

const ReligionMaster = () => {

  const storedBranchId = sessionStorage.getItem("branch_id");


  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  // --- FORM STATES USING useState ---
  const [religionName, setReligionName] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchReligions();
  }, []);


  const fetchReligions = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${GetReligionMaster}`);

      const formatted = res.data.map((item, index) => ({
        key: item.id,
        index: index + 1,
        religion_name: item.religion_name,
      }));

      setData(formatted);
    } catch (err) {
      toast.error("Failed to load Religions");
    }finally {
    setLoading(false);
  }
  };

  // --- OPEN MODAL ---
  const handleOpenModal = (record = null) => {
    if (record) {
      setEditingId(record.key);
      setReligionName(record.religion_name);
    } else {
      setEditingId(null);
      setReligionName("");
    }
    setIsModalOpen(true);
  };

  // --- SAVE OR UPDATE ---
  const handleSave = async () => {
    if (!religionName.trim()) return toast.error("Please enter Religion name");

    const payload = {
      religion_name: religionName,
    };

    try {
      if (editingId) {
        const res = await axios.put(`${UpdateReligionMaster}/${editingId}`, payload);
        if (res.data === "UPDATED") {
          toast.success("Religion updated successfully");
        }
      } else {
        const res = await axios.post(CreateReligionMaster, payload);
        if (res.data === "SAVED") {
          toast.success("Religion added successfully");
        }
      }

      fetchReligions();
      setIsModalOpen(false);
      setEditingId(null);
      setReligionName("");
    } catch (err) {
      toast.error("Failed to save Religion");
    }
  };




  // --- SEARCH ---
  const filteredData = data.filter((item) =>
    ((item.religion_name ?? "") + "").toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { title: "Sr No", dataIndex: "index" },
    { title: "Religion", dataIndex: "religion_name" },
    {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleOpenModal(record)}
          />
        </Space>
      ),
    },
  ];

  return (
    <div className="form-container mainContainer">

     <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">

        <div className="header-row">
          <h2 className="page-title">Religion Master</h2>
        </div>

      <div className="search-bar">
        <Input
          placeholder="Search Religion..."
          prefix={<SearchOutlined />}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 250 }}
        />

        <Button
          type="primary"
          className="mt-2 mt-md-0"
          icon={<PlusOutlined />}
          onClick={() => handleOpenModal()}
          style={{ marginLeft: 10 }}
        >
          Add Religion
        </Button>
      </div>

      <Table columns={columns} dataSource={filteredData} pagination={{ pageSize: 10 }} bordered loading={loading} scroll={{ x: 'max-content' }} />


      </div>
        <div className="col-12 col-md-2"></div>
      </div>

      <Modal
        title={editingId ? "Edit Religion" : "Add Religion"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSave}>
            Save
          </Button>,
        ]}
      >

        <div>
          <label>Religion Name</label>
          <Input
            value={religionName}
            onChange={(e) => setReligionName(e.target.value)}
            placeholder="Enter Religion name"
          />
        </div>
      </Modal>
    </div>
  );
};

export default ReligionMaster;
